module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogIzdhODA4OTsNCiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOw0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPHBhdGggaWQ9IumrmOe6p+e8lui+kSIgY2xhc3M9ImNscy0xIiBkPSJNMTI2Mi41LDc1My45Vjc2NWgtM1Y3NTMuOUgxMjUzVjc1MWgxNnYyLjloLTYuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjUyIC03NDkpIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/seniorEditor0.svg
// module id = OJxR
// module chunks = 1